import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Pipe({
  name: 'safe',
  standalone: true,
})
export class SafePipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) {}

  transform(value: string, type = 'url'): SafeUrl {
    if (!value) {
      return '';
    }

    return this.domSanitizer.bypassSecurityTrustUrl(value);
  }
}
